import URL_C from '@/http/achat/common';

export default {
  data: function () {
    return {};
  },
  methods: {
    /**Prix */
    updatePrixArticles(articlesPrix, itemLists) {
      itemLists.map((item) => {
        let finderT = window._.find(
          articlesPrix,
          (ap) => ap.article === item.article
        );
        if (finderT) {
          if (finderT.prix !== 0) this.$set(item, 'prix', finderT.prix);
          if (finderT.tva !== 0) this.$set(item, 'tva', finderT.tva);
        }
      });
    },
    getPrixArticles(itemLists, tiers) {
      let articles = itemLists
        .filter((item) => item.article !== null)
        .map((item) => item.article);

      window.axios
        .get(URL_C.GET_PRIX_ARTICLES, {
          params: {
            type: 'fournisseur',
            tiers: tiers,
            articles: articles !== null ? articles : [],
          },
        })
        .then((resp) => {
          this.updatePrixArticles(resp.data.prix, itemLists);
        })
        .catch();
    },

    /**Budget */
    updateBudgetArticles(articlesBudget, itemLists) {
      itemLists.map((item) => {
        let finderT = window._.find(
          articlesBudget,
          (ap) => ap.article === item.article
        );
        if (finderT) {
          this.$set(item, 'consommation', finderT.consommation);
          this.$set(item, 'etat', finderT.etat);
        }
      });
    },
    getBudgetArticles(itemLists, centreCout, annee) {
      let articles = itemLists
        .filter((item) => item.article !== null)
        .map((item) => item.article);

      window.axios
        .get(URL_C.GET_BUDGET_ARTICLES, {
          params: {
            centre_cout: centreCout,
            annee: annee,
            articles: articles !== null ? articles : [],
          },
        })
        .then((resp) => {
          this.updateBudgetArticles(resp.data.budgets, itemLists);
        })
        .catch();
    },
  },
};
